import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";
// import { SocketContext } from "../../context/Socket/SocketContext";
import n8n from "../../assets/n8n.png";
import dialogflow from "../../assets/dialogflow.png";
import webhooks from "../../assets/webhook.png";
import typebot from "../../assets/typebot.jpg";
import flowbuilder from "../../assets/flowbuilders.png"

import { makeStyles } from "@material-ui/core/styles";

import {
  Avatar,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from "@material-ui/core";

import {
  DeleteOutline,
  Edit
} from "@material-ui/icons";

import SearchIcon from "@material-ui/icons/Search";

import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import IntegrationModal from "../../components/QueueIntegrationModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForbiddenPage from "../../components/ForbiddenPage";

const reducer = (state, action) => {
  if (action.type === "LOAD_INTEGRATIONS") {
    const queueIntegration = action.payload;
    const newState = [...state];

    queueIntegration.forEach((integration) => {
      const integrationIndex = newState.findIndex((u) => u.id === integration.id);
      if (integrationIndex !== -1) {
        newState[integrationIndex] = integration;
      } else {
        newState.push(integration);
      }
    });

    return newState;
  }

  if (action.type === "UPDATE_INTEGRATIONS") {
    const queueIntegration = action.payload;
    const integrationIndex = state.findIndex((u) => u.id === queueIntegration.id);

    if (integrationIndex !== -1) {
      const newState = [...state];
      newState[integrationIndex] = queueIntegration;
      return newState;
    } else {
      return [queueIntegration, ...state];
    }
  }

  if (action.type === "DELETE_INTEGRATION") {
    const integrationId = action.payload;

    const integrationIndex = state.findIndex((u) => u.id === integrationId);
    if (integrationIndex !== -1) {
      const newState = [...state];
      newState.splice(integrationIndex, 1);
      return newState;
    }
    return state;
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(0),
    margin: theme.spacing(0),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    border: "none",
  },
  avatar: {
    width: "140px",
    height: "40px",
    borderRadius: 4
  },
}));

const QueueIntegration = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [deletingUser, setDeletingUser] = useState(null);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [queueIntegration, dispatch] = useReducer(reducer, []);
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const { getPlanCompany } = usePlans();
  const companyId = user.companyId;
  const history = useHistory();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useIntegrations) {
        toast.error("Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.");
        setTimeout(() => {
          history.push(`/`)
        }, 1000);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchIntegrations = async () => {
        try {
          const { data } = await api.get("/queueIntegration/", {
            params: { searchParam, pageNumber },
          });
          dispatch({ type: "LOAD_INTEGRATIONS", payload: data.queueIntegrations });
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchIntegrations();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber]);

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    const onQueueEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_INTEGRATIONS", payload: data.queueIntegration });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_INTEGRATION", payload: +data.integrationId });
      }
    };

    socket.on(`company-${companyId}-queueIntegration`, onQueueEvent);
    return () => {
      socket.off(`company-${companyId}-queueIntegration`, onQueueEvent);
    };
  }, [socket, companyId]);

  const handleOpenUserModal = () => {
    setSelectedIntegration(null);
    setUserModalOpen(true);
  };

  const handleCloseIntegrationModal = () => {
    setSelectedIntegration(null);
    setUserModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditIntegration = (queueIntegration) => {
    setSelectedIntegration(queueIntegration);
    setUserModalOpen(true);
  };

  const handleDeleteIntegration = async (integrationId) => {
    try {
      await api.delete(`/queueIntegration/${integrationId}`);
      toast.success(i18n.t("queueIntegration.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingUser(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: "100%" }}>
      <ConfirmationModal
        title={
          deletingUser &&
          `${i18n.t("queueIntegration.confirmationModal.deleteTitle")} ${deletingUser.name
          }?`
        }
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteIntegration(deletingUser.id)}
      >
        {i18n.t("queueIntegration.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <IntegrationModal
        open={userModalOpen}
        onClose={handleCloseIntegrationModal}
        aria-labelledby="form-dialog-title"
        integrationId={selectedIntegration && selectedIntegration.id}
      />
      {user.profile === "user" ?
        <ForbiddenPage />
        :
        <>
          <Card elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Box>
                  <Typography variant="h6" color="primary" gutterBottom fontWeight="bold">
                    Provedores e Integrações
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Configure plataformas externas como Dialogflow, N8N, Webhooks, Typebot e Flowbuilder.
                  </Typography>
                </Box>
                <Box display="flex" gap={1}>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenUserModal}
                  >
                    {i18n.t("queueIntegration.buttons.add")}
                  </Button>
                </Box>
              </Box>
          <Paper
            className={classes.mainPaper}
            elevation={0}
            variant="outlined"
            onScroll={handleScroll}
            style={{ backgroundColor: "transparent", border: "none", padding: "16px" }}
          >
            <Grid container spacing={2}>
              {queueIntegration.map((integration) => (
                <Grid item xs={12} sm={6} md={4} xl={3} key={integration.id}>
                  <Card elevation={0} sx={{ borderRadius: 2, height: "100%", border: "1px solid", borderColor: "divider" }}>
                    <CardContent>
                      <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                        <Box display="flex" alignItems="center" gap={2}>
                          {integration.type === "dialogflow" && (<Avatar src={dialogflow} className={classes.avatar} />)}
                          {integration.type === "n8n" && (<Avatar src={n8n} className={classes.avatar} />)}
                          {integration.type === "webhook" && (<Avatar src={webhooks} className={classes.avatar} />)}
                          {integration.type === "typebot" && (<Avatar src={typebot} className={classes.avatar} />)}
                          {integration.type === "flowbuilder" && (<Avatar src={flowbuilder} className={classes.avatar} />)}
                          
                          {(!integration.type || !['dialogflow', 'n8n', 'webhook', 'typebot', 'flowbuilder'].includes(integration.type)) && (
                            <Typography variant="subtitle1" fontWeight="bold">{integration.type}</Typography>
                          )}
                        </Box>

                        <Box display="flex">
                          <IconButton size="small" onClick={() => handleEditIntegration(integration)}>
                            <Edit color="secondary" />
                          </IconButton>
                          <IconButton size="small" onClick={(e) => {
                            setConfirmModalOpen(true);
                            setDeletingUser(integration);
                          }}>
                            <DeleteOutline color="error" />
                          </IconButton>
                        </Box>
                      </Box>
                      
                      <Typography variant="h6" color="primary" fontWeight="bold" mt={2}>
                        {integration.name}
                      </Typography>
                      <Typography variant="caption" color="textSecondary" display="block">
                        ID: {integration.id}
                      </Typography>

                    </CardContent>
                  </Card>
                </Grid>
              ))}
              {loading && (
                <Grid item xs={12}>
                  <TableRowSkeleton columns={4} />
                </Grid>
              )}
            </Grid>
          </Paper>
            </CardContent>
          </Card>
        </>}
    </Box>
  );
};

export default QueueIntegration;